<template functional>
    <div
        class="VButton noselect"
        :class="[`VButton-${props.type} VButton_${props.theme}`
        ,props.isActive ?  'VButton_active': '',props.disabled ? 'VButton_disabled':'']"
        v-on="listeners.click && !props.disabled ? { click: listeners.click } : null"
    >
        <div class="VButton__title">
            <slot></slot>
            <span
                v-if="props.changes"
                :class="[typeof props.changes === 'string' || (typeof props.changes === 'number' &&
                    props.changes >= 0) ? 'VButton_positive' : 'VButton_negative']"
            >({{ props.changes }})</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'VButton',
        props: {
            changes: {
                type: [Number, String],
                required: false,
            },
            type: {
                type: String,
                required: false,
                default: 'select',
            },
            isActive: {
                type: Boolean,
                default: false,
            },
            theme: {
                type: String,
                required: false,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .VButton {
        cursor: pointer;
        display: flex;
        white-space: nowrap;
        padding: 12px 16px;
        font-weight: 500;
        border-radius: 5px;
        background-color: #FFFFFF;
        position: relative;
        
        &__title {
            margin-right: 31px;
        }
        
        &-select {
            border: 1px solid $primary-color;
            padding-right: 0;
            
            
            &::after {
                content: "\2039";
                color: $secondary-color;
                font-size: 23px;
                position: absolute;
                transform: rotate(
                        -90deg
                );
                font-weight: bold;
                right: 20px;
                top: 8px;
            }
        }
        
        &_active {
            
            &.VButton-select {
                border: 1px solid #FFFFFF;
                box-shadow: 0 3px 6px 0 rgba(133, 126, 207, 0.3);
                border-radius: 5px 5px 0 0;
                
                &::before {
                    content: "";
                    width: 101.5%;
                    height: 12px;
                    position: absolute;
                    left: -1px;
                    top: 32px;
                    background: #ffffff;
                    z-index: 99;
                }
                
                &::after {
                    transform: rotate(
                            90deg
                    );
                    right: 15px;
                }
            }
        }
        &_disabled {
            opacity: .5;
            cursor: not-allowed;
        }
        
        &-button {
            color: white;
            border: 1px solid $primary-color;
            font-size: 16px;
            line-height: 20px;
            align-items: center;
            text-align: center;
            justify-content: center;
            //height: 35px;
            padding: 6px 15px 7px 16px;
            font-weight: 600;
        }
        
        &_positive {
            color: $positive-color;
        }
        
        &_negative {
            color: $negative-color;
        }
        
        &_green {
            background: $secondary-color;
        }
        
        &_dark-blue {
            background: $primary-color;
        }
        
        &_red {
            background: red;
        }
        
        &_light-blue {
            color: $primary-color;
            border: none;
            background: $light-blue-color;
        }
    }
</style>
